var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83398 0.333984C7.2612 0.334148 7.61301 0.655969 7.66113 1.07031L7.66699 1.16699V6.16699H12.667C13.1272 6.16699 13.5 6.54074 13.5 7.00098C13.4998 7.42802 13.1788 7.77978 12.7646 7.82812L12.667 7.83398H7.66699V12.834C7.66699 13.2941 7.29407 13.6668 6.83398 13.667C6.40678 13.667 6.0542 13.3459 6.00586 12.9316L6 12.834V7.83398H1C0.540021 7.83381 0.167168 7.46096 0.166992 7.00098C0.166992 6.57361 0.488871 6.22099 0.90332 6.17285L1 6.16699H6V1.16699C6.00018 0.706904 6.37386 0.333984 6.83398 0.333984Z",
    fill: "#51597B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizPlus);
export default __webpack_public_path__ + "static/media/quiz-plus.26c8ac7811b3ef8f5eee65fe3f4f0022.svg";
export { ForwardRef as ReactComponent };